import type { JSX, ReactNode } from 'react';
import { mensagemDoErro } from '../lib/api.js';
import './Estados.css';

/**
 * Carregando, erro e vazio — Story 8.1.
 *
 * Ficam num lugar só porque são o que o usuário mais vê quando algo foge do
 * caminho feliz, e porque três telas inventando cada uma o seu "carregando"
 * é como uma interface começa a parecer remendo.
 */

export function Carregando({ rotulo = 'Carregando…' }: { rotulo?: string }): JSX.Element {
  return (
    <div className="estado" role="status" aria-live="polite">
      <span className="estado__giro" aria-hidden="true" />
      <p className="estado__texto">{rotulo}</p>
    </div>
  );
}

/**
 * Erro **com ação de repetir**: uma tela de erro sem saída obriga o usuário a
 * recarregar a página na mão, e ele perde o que estava fazendo.
 */
export function Erro({ erro, aoRepetir }: { erro: unknown; aoRepetir?: () => void }): JSX.Element {
  return (
    <div className="estado" role="alert">
      <p className="estado__titulo">Não deu para carregar</p>
      <p className="estado__texto">{mensagemDoErro(erro)}</p>
      {aoRepetir !== undefined && (
        <button type="button" className="botao botao--neutro" onClick={aoRepetir}>
          Tentar de novo
        </button>
      )}
    </div>
  );
}

export function Vazio({
  titulo,
  descricao,
  acao,
}: {
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
}): JSX.Element {
  return (
    <div className="estado">
      <p className="estado__titulo">{titulo}</p>
      {descricao !== undefined && <p className="estado__texto">{descricao}</p>}
      {acao}
    </div>
  );
}
